const stateLabels: Record<string, string> = {
  registration: 'Iscrizioni aperte',
  running: 'In corso',
  completed: 'Completato',
  cancelled: 'Annullato',

  queued: 'In attesa di un’arena',
  waiting_players: 'In attesa dei giocatori',
  assigned: 'Assegnato',
  live: 'In diretta',
  forfeit: 'Vittoria a tavolino',

  registered: 'Iscritto',
  active: 'Attivo',
  waiting: 'In attesa',
  playing: 'In partita',
  advanced: 'QUALIFICATO',
  eliminated: 'ELIMINATO',
  champion: 'CAMPIONE',
}

const placementLabels: Record<string, string> = {
  top_64: 'Top 64',
  top_32: 'Top 32',
  top_16: 'Top 16',
  top_8: 'Top 8',
  quarterfinalist: 'Quarti di finale',
  semifinalist: 'Semifinalista',
  runner_up: 'Secondo posto',
  champion: 'Campione',
  cancelled: 'Annullato',
}

function fallback(value: string): string {
  return value
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (character) => character.toUpperCase())
}

export function tournamentStateLabel(value: string): string {
  const normalized = value.trim().toLowerCase()
  return stateLabels[normalized] ?? fallback(normalized)
}

export function tournamentPlacementLabel(
  value: string | null,
): string | null {
  if (!value) return null
  const normalized = value.trim().toLowerCase()
  return placementLabels[normalized] ?? fallback(normalized)
}
